import {ChangeDetectionStrategy, Component, input} from '@angular/core'
import {ChipComponent} from '../../chip/chip.component'
import {I18nDirective} from '../../i18n/i18n.directive'
import {MinimumPriceTextComponent} from './minimum-price-text.component'

@Component({
  selector: 'cft-minimum-price',
  changeDetection: ChangeDetectionStrategy.OnPush,
  styles: [':host { display: block }'],
  standalone: true,
  imports: [ChipComponent, I18nDirective, MinimumPriceTextComponent],
  template: `
    <cft-chip colour="purple" *cftI18n="let t" [size]="size()">
      <cft-minimum-price-text [minimumPrice]="minimumPrice()"></cft-minimum-price-text>
    </cft-chip>
  `,
})
export class MinimumPriceComponent {
  minimumPrice = input.required<number>()
  size = input<'xs' | 'sm' | 'base' | 'default'>('default')
}
